import type { SVGProps } from 'react';
const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x={0.5} y={0.5} width={31} height={31} rx={15.5} fill="#1D1D1B" />
        <path
            d="M17.7795 12.2246L14.2202 15.9996L17.7795 19.7746"
            stroke="white"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect x={0.5} y={0.5} width={31} height={31} rx={15.5} stroke="#1D1D1B" />
    </svg>
);
export default ArrowLeft;
